import request from './request'

export interface CareTemplateDetailParams {
  id: number
}

export interface CareTemplateCandidate {
  baseline: unknown[]
  routine: unknown[]
}

export interface CareTemplateDetailData {
  id: number
  template_name: string
  plan_key: string
  start_month: number | null
  end_month: number | null
  month: number | null
  estimated_hours: number
  estimated_minutes: number
  baseline_checklist_ids: number[]
  routine_checklist_ids: number[]
  candidates: CareTemplateCandidate
}

export interface CareTemplateDetailResponse {
  code: number
  msg: string
  data?: CareTemplateDetailData
}

export function getCareTemplateDetail(
  params: CareTemplateDetailParams,
): Promise<CareTemplateDetailResponse> {
  //return request.post('/api/admin/care-template/detail', params)
  return request.post('/api/admin/care-template/detail', params)
  //Edit by Roshan

}
